import { render, staticRenderFns } from "./WsDialogPicker.vue?vue&type=template&id=1c89ec3c&"
import script from "./WsDialogPicker.vue?vue&type=script&lang=js&"
export * from "./WsDialogPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports